export default __webpack_public_path__ + "850d27ed7fc206dc9ec81feb8c4ad9f1.jpg";